import { render } from "./CustomerFormShortDetailsModal.vue?vue&type=template&id=fcc46288"
import script from "./CustomerFormShortDetailsModal.vue?vue&type=script&lang=js"
export * from "./CustomerFormShortDetailsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__